/* eslint-disable react/prop-types */
/* eslint-disable import/no-named-as-default */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable camelcase */
import React, {
  Suspense,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import loadable, { lazy } from '@loadable/component';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import MediaQuery from 'react-responsive';
import { useHistory } from 'react-router';
import { compose } from 'recompose';

// import Reconnecting from 'components/Reconnecting';
import { changeContractType } from 'actions/trade';
import { isAuthenticated, updateUserPreference } from 'actions/user';
import { TAB_CHANGE } from 'actionTypes/appDrawer';
// import TableHeaders from 'components/Header/partials/headerDropdown/TableHeaders';
import { AccountCreatedGetVerifiedModal } from 'components/AccountCreatedGetVerifiedModal';
import AddPhoneNumberModal from 'components/AddPhoneNumberModal';
import Render from 'components/render';
import Seo from 'components/seo';
import StraddleIntro from 'components/StraddleIntro';
import TrackerInfo from 'components/TrackerInfo/TrackerInfo';
import TrackerIntroSlides from 'components/TrackerIntroSlides';
import UserJourneyCards from 'components/UserJourneyPopups/UserJourneyCard';
import {
  CONTRACT_TYPE,
  IND_DOMAIN_SWITCH,
  IS_DEMO,
  IS_INDIAN_EXCHANGE,
} from 'constants/constants';
import { MIXPANEL_EVENT_NAMES } from 'constants/mixpanelEventNames';
import { getDecoratedMarketProducts } from 'decorators/marketProducts';
import { trackMixpanelEvent, trackMixpanelEventPageView } from 'helpers/mixpanel-init';
import { contains, filter, isEmpty } from 'helpers/ramda';
import { device } from 'helpers/screenSizes';
import {
  getProductUrlByContractType,
  isFutures,
  searchConditions,
  sortFundsByStats,
} from 'helpers/utils';
import useWindowSize from 'hooks/useWindowSize';
// import PropTypes from 'PropTypes';
import { APP_DRAWER_TAB_ID_MAPPING } from 'reducers/initialstate/appDrawer';
import { userPreferencesSelector } from 'selectors/otherSelectors';
import {
  sortProductsByLastPriceChange,
  sortProductsByVolume,
} from 'selectors/tickerSelectors';
import {
  contractTypeSelector,
  OptionChainsProductList,
  productsListSelector,
} from 'selectors/tradeSelectors';
import { ContractType } from 'types/IProducts';

import { getFavoritesFromAllProductsList } from './helpers';
import styles from './index.module.scss';
import DynamicLoader from './loader';
import { BannerProvider } from './partials/cardsArea/OffersAndPromotionCards/useMarketsBanner';
import TopSectionCards from './partials/cardsArea/TopSectionCards';
import MarketsContractTypeHeader from './partials/contractTypeHeader';
import FuturesTabStrip from './partials/futuresTabStrip';
import OptionsCombosFilterStrip, {
  MobileOptionsCombosFilterStrip,
} from './partials/OptionsCombosFilterStrip';

const AsyncOptionsAnalyticsDashboard = loadable(() =>
  import(
    /* webpackChunkName: 'OptionsAnalyticsDashboard' */ 'containers/OptionsAnalyticsDashboard'
  )
);

const OptionsChainMobile = lazy(() =>
  import(
    /* webpackChunkName: "OptionsChainMobile" */ 'components/Header/partials/headerDropdown/OptionsChain'
  )
);

const OptionsChain = lazy(() =>
  import(/* webpackChunkName: "OptionsChainDesktop" */ './partials/OptionsChain')
);

const MarketsTable = loadable(
  () => import(/* webpackChunkName: "MarketsTable" */ './MarketsTable'),
  { fallback: <DynamicLoader desktopVariant="others" /> }
);

const getMetaTitle = (contract_type, handleLocalizedMeta) => {
  // switch (contract_type) {
  //   case 'futures':
  //   case 'perpetual_futures':
  //     return handleLocalizedMeta('title', 'perpetual_futures');
  //   case 'move_options':
  //     return handleLocalizedMeta('title', 'move_options');
  //   case 'interest_rate_swaps':
  //     return handleLocalizedMeta('title', 'interest_rate_swaps');
  //   case 'spreads':
  //     return handleLocalizedMeta('title', 'spreads');
  //   case 'spot':
  //     return handleLocalizedMeta('title', 'spot');
  //   case 'options_chain':
  //     return handleLocalizedMeta('title', 'options_chain');
  //   case 'robo':
  //     return handleLocalizedMeta('title', 'robo');
  //   case 'favorites':
  //     return handleLocalizedMeta('title', 'favorites');
  //   default:
  //     return '';
  // }
  if (IS_DEMO) {
    return handleLocalizedMeta('title', 'demoTrading');
  }
  if (contract_type === 'futures' || contract_type === 'perpetual_futures') {
    return handleLocalizedMeta('title', 'perpetual_futures');
  }
  return handleLocalizedMeta('title', contract_type);
};

const getMetaDesc = (contract_type, handleLocalizedMeta) => {
  // switch (contract_type) {
  //   case 'futures':
  //   case 'perpetual_futures':
  //     return handleLocalizedMeta('description', 'perpetual_futures');
  //   case 'move_options':
  //     return handleLocalizedMeta('description', 'move_options');
  //   case 'interest_rate_swaps':
  //     return handleLocalizedMeta('description', 'interest_rate_swaps');
  //   case 'spreads':
  //     return handleLocalizedMeta('description', 'spreads');
  //   case 'spot':
  //     return handleLocalizedMeta('description', 'spot');
  //   case 'options_chain':
  //     return handleLocalizedMeta('description', 'options_chain');
  //   case 'robo':
  //     return handleLocalizedMeta('description', 'robo');
  //   case 'favorites':
  //     return handleLocalizedMeta('description', 'favorites');
  //   default:
  //     return '';
  // }
  if (IS_DEMO) {
    return handleLocalizedMeta('description', 'demoTrading');
  }
  if (contract_type === 'futures' || contract_type === 'perpetual_futures') {
    return handleLocalizedMeta('description', 'perpetual_futures');
  }
  return handleLocalizedMeta('description', contract_type);
};

const getKeywords = (contract_type, handleLocalizedMeta) => {
  // switch (contract_type) {
  //   case 'futures':
  //   case 'perpetual_futures':
  //     return handleLocalizedMeta('keywords', 'perpetual_futures');
  //   case 'move_options':
  //     return handleLocalizedMeta('keywords', 'move_options');
  //   case 'interest_rate_swaps':
  //     return handleLocalizedMeta('keywords', 'interest_rate_swaps');
  //   case 'spreads':
  //     return handleLocalizedMeta('keywords', 'spreads');
  //   case 'spot':
  //     return handleLocalizedMeta('keywords', 'spot');
  //   case 'options_chain':
  //     return handleLocalizedMeta('keywords', 'options_chain');
  //   case 'robo':
  //     return handleLocalizedMeta('keywords', 'robo');
  //   case 'favorites':
  //     return handleLocalizedMeta('keywords', 'favorites');
  //   default:
  //     return '';
  // }
  if (contract_type === 'futures' || contract_type === 'perpetual_futures') {
    return handleLocalizedMeta('keywords', 'perpetual_futures');
  }
  return handleLocalizedMeta('keywords', contract_type);
};

const Markets = props => {
  const { t } = useTranslation(['markets']);
  const favoritesIds =
    useSelector(state => userPreferencesSelector(state))?.favorites || [];
  favoritesIds.sort((elem1, elem2) => elem2 - elem1);

  const allProducts = useSelector(state => productsListSelector(state));
  const favorites = getDecoratedMarketProducts({
    productsList: getFavoritesFromAllProductsList(allProducts, favoritesIds),
  });
  const isLoggedIn = useSelector(({ user }) => isAuthenticated(user));
  const [showTrackerIntro, setShowTrackerIntro] = useState(false);

  const {
    products,
    match: {
      params: { contractType },
    },
    fundsList,
    // yieldStrategies,
  } = props;

  const history = useHistory();
  const { isMobile } = useWindowSize();

  // usePaletteTags('markets');

  const [activeProducts, setActiveProducts] = useState([]);
  const [selectedSettlingAsset, setSelectedSettlingAsset] = useState('All');
  const [selectedUnderlyingAsset, setSelectedUnderlyingAsset] = useState('All');
  const [optionContractType, setOptionContractType] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const [reset, setReset] = useState(false);
  const [showFunds, setShowFunds] = useState(false);
  const [activeFunds, setActiveFunds] = useState([]);
  const filterTimerRef = useRef(null);
  const [sortBy, setSortBy] = useState({ field: '', direction: '' });

  const noProducts = !activeProducts.length;
  const selectedContractType = useSelector(contractTypeSelector);
  const { underlyingAssetSymbolList } = useSelector(OptionChainsProductList);
  const [activeProductsTags, setActiveProductsTags] = useState([]);
  const [selectedTag, setSelectedTag] = useState('all');
  const dispatch = useDispatch();

  const filterByUnderlyingAsset = ({ value }) => {
    setSelectedUnderlyingAsset(value);
  };

  const filterByOptionsContractType = ({ value }) => {
    setOptionContractType(value);
  };

  const filterBySettlingAsset = ({ value }) => {
    setSelectedSettlingAsset(value);
  };

  const onRowClickFunc = useCallback(
    product => {
      const { symbol, contract_type, underlying_asset } = product;
      if (!showFunds) {
        const url = getProductUrlByContractType(
          contract_type,
          underlying_asset.symbol,
          symbol
        );
        // Switch to trade tab (for mobile).
        dispatch({
          type: TAB_CHANGE,
          payload: APP_DRAWER_TAB_ID_MAPPING.TRADE,
        });
        history.push(url);
      } else {
        const fundName = symbol.split('_').join('-').toLowerCase();
        window.location.href = `/invest/robo-strategies/${fundName}`;
      }
      if (isMobile && contract_type === 'options_combos') {
        trackMixpanelEvent(MIXPANEL_EVENT_NAMES.MARKETS.TRADE_OPTION_COMBOS, {
          source: 'all markets',
          product_name: symbol,
          product_type: contract_type,
        });
      } else {
        trackMixpanelEvent(
          contract_type === ContractType.MoveOptions
            ? MIXPANEL_EVENT_NAMES.MOVE_TRADING_VIEW_INITIATED
            : MIXPANEL_EVENT_NAMES.MARKETS.TRADE_OPTION,
          {
            source: 'all markets',
            product_name: symbol,
            product_type: contract_type,
          }
        );
      }
    },
    [showFunds]
  );

  const handleOptionProductListFilter = useCallback(
    (
      optionContractType,
      selectedUnderlyingAsset,
      products,
      searchTerm,
      selectedContType
    ) => {
      let productList;
      // filter by search
      if (searchTerm) {
        productList = filter(product => searchConditions(product, searchTerm), products);
      } else {
        productList = products;
      }

      if (optionContractType === 'All' && selectedUnderlyingAsset === 'All') {
        setActiveProducts(productList);
      } else if (optionContractType === 'All' && selectedUnderlyingAsset !== 'All') {
        setActiveProducts(
          filter(
            product =>
              contains(selectedContType, product.contract_type) &&
              product.currency === selectedUnderlyingAsset,
            productList
          )
        );
      } else if (optionContractType !== 'All' && selectedUnderlyingAsset === 'All') {
        setActiveProducts(
          filter(product => product.contract_type === optionContractType, productList)
        );
      } else if (
        selectedContractType === 'favorites' &&
        favorites &&
        favorites.length > 0
      ) {
        setActiveProducts(favorites);
      } else {
        setActiveProducts(
          filter(
            product =>
              product.contract_type === optionContractType &&
              product.currency === selectedUnderlyingAsset,
            productList
          )
        );
      }
    },
    []
  );

  const FilterProducts = useCallback(
    searchTerm => {
      if (showFunds) {
        let fundList;
        if (!isEmpty(searchTerm)) {
          fundList = filter(
            product =>
              product.short_description.toLowerCase().includes(searchTerm.toLowerCase()),
            fundsList
          );
        } else {
          fundList = fundsList;
        }
        setActiveFunds(fundList);
      }

      if (
        contractType !== CONTRACT_TYPE.FUTURES &&
        contractType !== CONTRACT_TYPE.OPTIONS
      ) {
        let productList;
        if (!isEmpty(searchTerm)) {
          productList = filter(
            product => searchConditions(product, searchTerm),
            products
          );
        } else {
          productList = products;
        }
        setActiveProducts(productList);
      }

      if (contractType === CONTRACT_TYPE.FUTURES) {
        let productList;
        if (!isEmpty(searchTerm)) {
          productList = filter(
            product => searchConditions(product, searchTerm),
            products
          );
        } else {
          productList = products;
        }

        if (selectedSettlingAsset !== 'All') {
          productList = filter(
            product => product.settling_asset.symbol === selectedSettlingAsset,
            productList
          );
        }
        setActiveProducts(filterFuturesByTag(productList));
      }

      if (contractType === CONTRACT_TYPE.OPTIONS) {
        handleOptionProductListFilter(
          optionContractType,
          selectedUnderlyingAsset,
          products,
          searchTerm,
          contractType
        );
      }

      if (selectedContractType === 'favorites' && favorites && favorites?.length > 0) {
        let filteredFavorites;
        if (!isEmpty(searchTerm)) {
          filteredFavorites = filter(
            favorite => searchConditions(favorite, searchTerm),
            favorites
          );
        } else {
          filteredFavorites = favorites;
        }
        setActiveProducts(filteredFavorites);
      }
    },
    [
      contractType,
      fundsList,
      products,
      showFunds,
      handleOptionProductListFilter,
      optionContractType,
      selectedSettlingAsset,
      selectedUnderlyingAsset,
      selectedTag,
    ]
  );

  const onSearchChange = useCallback(value => {
    setSearchTerm(value);
  }, []);

  useEffect(() => {
    clearTimeout(filterTimerRef.current);
    filterTimerRef.current = setTimeout(() => {
      FilterProducts(searchTerm);
    }, 300);
  }, [searchTerm, FilterProducts]);

  const filterFuturesByTag = futures => {
    if (selectedTag === 'all') {
      return futures;
    }
    if (selectedTag === 'new') {
      return futures.filter(
        future =>
          future.ui_config &&
          future.ui_config.tags &&
          future.ui_config.tags.some(tag => tag.match(/new/i))
      );
    }
    const filteredFutures = futures.filter(
      future =>
        future.product_specs &&
        future.product_specs.tags &&
        future.product_specs.tags.includes(selectedTag)
    );
    return filteredFutures;
  };

  // intially when we get product list from api.
  useEffect(() => {
    if (selectedContractType === 'favorites' && favorites && favorites.length > 0) {
      setActiveProducts(favorites);
    } else {
      setActiveProducts(products);
    }
    if (selectedContractType && isFutures(selectedContractType)) {
      const isNewProduct = products.some(product =>
        product?.ui_config?.tags?.some(tag => tag.match(/new/i))
      );

      const productsTags = [
        'all',
        ...(isNewProduct ? ['new'] : []),
        ...products.flatMap(product => product?.product_specs?.tags || []),
      ];
      const uniqueProductsTags = [...new Set(productsTags)];
      setActiveProductsTags(uniqueProductsTags);
    }
  }, [products]);

  // to get statistics data for each fund
  useEffect(() => {
    setActiveFunds(fundsList);
  }, [fundsList]);

  // useEffect to change contracttype
  useEffect(() => {
    setSearchTerm('');
    setReset(true);
    setSelectedUnderlyingAsset('All');
    setSelectedSettlingAsset('All');
    setOptionContractType('All');
    setActiveProducts([]);
    if (contractType === 'robo-strategies') {
      dispatch(changeContractType(''));
      setShowFunds(true);
    } else {
      dispatch(changeContractType(contractType));
      setShowFunds(false);
    }
  }, [contractType, dispatch]);

  useEffect(() => {
    trackMixpanelEventPageView({ page_name: 'All Markets Page' });
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleOnClick = value => {
    window.scrollTo(0, 180);
  };

  const activeProductIds = useMemo(() => {
    return activeProducts.map(elem => elem.id);
  }, [activeProducts]);

  const sortedProductsList = useMemo(() => {
    if (sortBy.field === 'volume') {
      return [...activeProducts].sort(sortProductsByVolume(sortBy.direction));
    }
    if (sortBy.field === 'change24') {
      return [...activeProducts].sort(sortProductsByLastPriceChange(sortBy.direction));
    }
    return activeProducts;
  }, [sortBy, activeProducts]);

  const sortedFundsList = useMemo(() => {
    if (sortBy.field === 'returns24') {
      return [...fundsList].sort(sortFundsByStats(sortBy.direction, '1d'));
    }
    if (sortBy.field === 'itd') {
      return [...fundsList].sort(sortFundsByStats(sortBy.direction, 'Inf'));
    }
    return fundsList;
  }, [sortBy, fundsList]);

  const setFavorite = productId => {
    if (isLoggedIn) {
      dispatch(
        updateUserPreference(
          {
            preferences: {
              favorites: favoritesIds.some(pid => pid === productId)
                ? favoritesIds.filter(pid => pid !== productId)
                : favoritesIds.concat(productId),
            },
          },
          { disable_notification: true }
        )
      );
      const product = products.find(x => x.id === productId);
      if (typeof product !== 'undefined') {
        const { symbol, contract_type } = product;
        if (!favoritesIds.find(pid => pid === productId)) {
          trackMixpanelEvent('Favorite Marked - Trade', {
            source: 'markets table',
            product_name: symbol,
            product_type: contract_type,
          });
        }
      }
    }
  };

  /** If sort by 24 Hours is active then sort the productList array */

  const handleLocalizedMeta = (type, key) => {
    let str = IS_INDIAN_EXCHANGE
      ? `markets:seoIndian.${type}.${key}`
      : `markets:seo.${type}.${key}`;
    if (IND_DOMAIN_SWITCH) {
      str = IS_INDIAN_EXCHANGE
        ? `markets:seoIndian.${type}.${key}_new`
        : `markets:seo.${type}.${key}_new`;
    }
    return t(str);
  };

  const isRoboStrategies = window.location.pathname.includes('robo-strategies');
  const roboStrategies = IS_DEMO ? [] : activeFunds;
  const allProductsDataLoaded = allProducts.length > 0;

  const title = getMetaTitle(
    isRoboStrategies ? 'robo' : selectedContractType,
    handleLocalizedMeta
  );

  const description = getMetaDesc(
    isRoboStrategies ? 'robo' : selectedContractType,
    handleLocalizedMeta
  );

  return (<>
    <Seo
      title={title}
      description={description}
      keywords={getKeywords(
        isRoboStrategies ? 'robo' : selectedContractType,
        handleLocalizedMeta
      )}
    />
    <div className={styles.markets} data-palette="Markets">
      {/* {(!props.isInternetConnected || props.isSocketReconnecting) && (
        <Reconnecting isSocketReconnecting={props.isSocketReconnecting} />
      )} */}

      <Render when={!IS_DEMO}>
        <BannerProvider>
          <MediaQuery query={device.up.md}>
            <TopSectionCards />
          </MediaQuery>
        </BannerProvider>
      </Render>

      <MarketsContractTypeHeader
        showFunds={showFunds}
        onSearchChange={onSearchChange}
        searchTerm={searchTerm}
        noProducts={noProducts}
        handleOnClick={handleOnClick}
        reset={reset}
        contractType={contractType}
      />
      <div>
        <MediaQuery query={device.up.md}>
          <FuturesTabStrip
            selectedContractType={selectedContractType}
            selectedTag={selectedTag}
            setSelectedTag={setSelectedTag}
            activeProductsTags={activeProductsTags}
            searchProps={{
              onSearchChange,
              searchTerm,
              noProducts,
              handleOnClick,
              reset,
            }}
          />
          <Render when={products.length && contractType === ContractType.OptionsCombos}>
            <OptionsCombosFilterStrip
              productList={products}
              setActiveProducts={setActiveProducts}
              searchTerm={searchTerm}
            />
          </Render>
        </MediaQuery>
        <MediaQuery query={device.down.md}>
          <FuturesTabStrip
            selectedContractType={selectedContractType}
            selectedTag={selectedTag}
            setSelectedTag={setSelectedTag}
            activeProductsTags={activeProductsTags}
          />
          <Render when={products.length && contractType === ContractType.OptionsCombos}>
            <MobileOptionsCombosFilterStrip
              productList={products}
              setActiveProducts={setActiveProducts}
              searchTerm={searchTerm}
            />
          </Render>
          <Render when={contractType === ContractType.Tracker && IS_INDIAN_EXCHANGE}>
            <TrackerInfo setShowTrackerIntro={setShowTrackerIntro} />
          </Render>
          <Render when={contractType === ContractType.MoveOptions}>
            <StraddleIntro />
          </Render>
        </MediaQuery>
      </div>
      <Suspense fallback={<DynamicLoader desktopVariant="options_chain" />}>
        <Render when={contractType === 'options_chain'}>
          <Render
            when={underlyingAssetSymbolList.length > 0}
            else={<DynamicLoader desktopVariant="options_chain" />}
          >
            <MediaQuery query={device.up.md}>
              <div
                className={cn(styles.optionsChainTable, {
                  [styles['funds-table']]: showFunds,
                })}
              >
                <OptionsChain />
              </div>
            </MediaQuery>

            <MediaQuery query={device.down.md}>
              <OptionsChainMobile />
            </MediaQuery>
          </Render>
        </Render>

        <Render when={contractType === 'options_analytics'}>
          <AsyncOptionsAnalyticsDashboard fromMarkets />
        </Render>

        <Render
          when={
            contractType !== 'options_chain' && contractType !== 'options_analytics'
          }
        >
          <Render
            when={allProductsDataLoaded}
            else={<DynamicLoader desktopVariant="others" />}
          >
            <MarketsTable
              activeProducts={activeProducts}
              activeProductIds={activeProductIds}
              chartHistory={props.chartHistory}
              favoritesIds={favoritesIds}
              filterByOptionsContractType={filterByOptionsContractType}
              filterBySettlingAsset={filterBySettlingAsset}
              filterByUnderlyingAsset={filterByUnderlyingAsset}
              fundsList={fundsList}
              getChartHistory={props.getChartHistory}
              onRowClickFunc={onRowClickFunc}
              optionContractType={optionContractType}
              roboStrategies={roboStrategies}
              searchTerm={searchTerm}
              selectedContractType={selectedContractType}
              selectedUnderlyingAsset={selectedUnderlyingAsset}
              selectedSettlingAsset={selectedSettlingAsset}
              setFavorite={setFavorite}
              setSortBy={setSortBy}
              showFunds={showFunds}
              sortBy={sortBy}
              sortedFundsList={sortedFundsList}
              sortedProductsList={sortedProductsList}
              noData={showFunds ? !roboStrategies.length : !activeProducts.length}
            />
          </Render>
        </Render>
      </Suspense>
      <MediaQuery query={device.up.md}>
        <AccountCreatedGetVerifiedModal />
        <Render when={!IS_DEMO}>
          <UserJourneyCards />
        </Render>
      </MediaQuery>
      <TrackerIntroSlides
        open={showTrackerIntro}
        onClose={() => setShowTrackerIntro(false)}
      />
      <AddPhoneNumberModal />
    </div>
  </>);
};

// Markets.propTypes = {
//   showLoader: PropTypes.bool.isRequired,
//   products: PropTypes.arrayOf(PropTypes.marketProducts).isRequired,
//   chartHistory: PropTypes.object.isRequired,
//   getChartHistory: PropTypes.func.isRequired,
//   isInternetConnected: PropTypes.bool.isRequired,
//   isSocketReconnecting: PropTypes.bool.isRequired,
// };

const enhance = compose(React.memo);

export { DynamicLoader };
export default enhance(Markets);
